<!-- @Version: 1.0.0 -->
<app-bank-logo-default data-testid="bank-logo-right"></app-bank-logo-default>

@if (showActionLogo) {
   <app-action-logo data-testid="action-logo-right"></app-action-logo>
}
